import { handleAPI, API_VERSION_ONE } from '../../../itrust_common/utils/apiUtils';
const parent = 'STORE_SETTING'

export function storeSettingLoad(filters) {
  const url = `/${API_VERSION_ONE}/store_settings`;
  const method = 'GET'

  return {
    type: `${parent}_LOAD`,
    payload: handleAPI(url, filters, method)
  };
}

export function storeSettingCreate(data, filters) {
  const url = `/${API_VERSION_ONE}/store_settings`;
  const method = 'POST'

  return {
    type: `${parent}_CREATE`,
    payload: handleAPI(url, filters, method, { store_setting: data })
  };
}

export function storeSettingUpdate(data, filters) {
  const url = `/${API_VERSION_ONE}/store_settings/${data.id}`;
  const method = 'PUT'
  return {
    type: `${parent}_UPDATE`,
    payload: handleAPI(url, filters, method, { store_setting: data })
  }
}

export function storeSettingPatch(data, filters) {
  const url = `/${API_VERSION_ONE}/store_settings/${data.id}`;
  const method = 'PATCH'
  return {
    type: `${parent}_UPDATE`,
    payload: handleAPI(url, filters, method, { store_setting: data })
  }
}

export function storeSettingDelete(id, filters) {
  const url = `/${API_VERSION_ONE}/store_settings/${id}`;
  const method = 'DELETE'
  return {
    type: `${parent}_DELETE`,
    payload: handleAPI(url, filters, method)
  }
}

export function storeSettingDevicesLoad(filters) {
  const url = `/${API_VERSION_ONE}/device_integrations`;
  const method = 'GET'
  return {
    type: `${parent}_DEVICES_LOAD`,
    payload: handleAPI(url, filters, method)
  }
}

export function storeSettingDeviceLoad(device_id, filters) {
  const url = `/${API_VERSION_ONE}/device_integrations/${device_id}`;
  const method = 'GET'
  return {
    type: `${parent}_DEVICE_LOAD`,
    payload: handleAPI(url, filters, method)
  }
}

export function storeSettingDeviceUpdate(data, filters) {
  const url = `/${API_VERSION_ONE}/device_integrations/${data.device_id}`;
  const method = 'PUT'
  return {
    type: `${parent}_DEVICE_UPDATE`,
    payload: handleAPI(url, filters, method, { device_integration: data })
  }
}
